'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAskForEmailMessage = exports.shouldAskForEmail = exports.getStagedChangesCount = exports.getDefaultRecipientId = exports.getRotateToOwner = exports.getAwayMessage = exports.getStagedMessage = undefined;

var _get = require('transmute/get');

var _get2 = _interopRequireDefault(_get);

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _reselect = require('reselect');

var _clientSelectors = require('conversations-core/selectors/clientSelectors');

var _widgetDataSelectors = require('conversations-core/selectors/widgetDataSelectors');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getMessages = (0, _getIn2.default)(['entities', 'messages']);

var getStagedPortalSettings = (0, _getIn2.default)(['portalSettings', 'serverSettings']);

var getStagedMessage = exports.getStagedMessage = (0, _get2.default)('editMessage');

var getAwayMessage = exports.getAwayMessage = (0, _reselect.createSelector)([getStagedMessage, getStagedPortalSettings], function (stagedMessage, stagedPortalSettings) {
  if (stagedMessage.customAwayMessage !== null) {
    return stagedMessage.customAwayMessage;
  }

  return stagedPortalSettings.customAwayMessage || _I18n2.default.text('default.awayMessage');
});

var getRotateToOwner = exports.getRotateToOwner = (0, _reselect.createSelector)([getStagedMessage, getStagedPortalSettings], function (stagedMessage, stagedPortalSettings) {
  if (stagedMessage.rotatingToOwner !== null) {
    return stagedMessage.rotatingToOwner;
  }
  return stagedPortalSettings.rotateToOwner;
});

var getDefaultRecipientId = exports.getDefaultRecipientId = (0, _reselect.createSelector)([getStagedMessage, getStagedPortalSettings], function (stagedMessage, stagedPortalSettings) {
  if (stagedMessage.fallbackUser !== null) {
    return stagedMessage.fallbackUser;
  }
  return stagedPortalSettings.defaultRecipientId;
});

var getStagedChangesCount = exports.getStagedChangesCount = (0, _reselect.createSelector)([getStagedMessage, getMessages], function (stagedMessage, messages) {
  var originalMessage = messages.get('' + stagedMessage.id);

  if (!originalMessage) {
    return 0;
  }

  return originalMessage.toMap().reduce(function (acc, value, key) {
    if (stagedMessage.get(key) !== value) {
      return acc + 1;
    }
    return acc;
  }, 0);
});

var shouldAskForEmail = exports.shouldAskForEmail = (0, _reselect.createSelector)([_clientSelectors.getIsAdmin, _widgetDataSelectors.getAskForEmail], function (isAdmin, askForEmail) {
  if (isAdmin) return false;

  return askForEmail;
});

var getAskForEmailMessage = exports.getAskForEmailMessage = (0, _reselect.createSelector)([getStagedMessage], function (stagedMessage) {
  if (stagedMessage.askForEmailMessage !== null) {
    return stagedMessage.askForEmailMessage;
  }

  return _I18n2.default.text('default.askForEmailMessage');
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-core/static-1.139/js/selectors/messageSelectors.js
// module id = 198
// module chunks = 0 1